import { render, staticRenderFns } from "./appConfig.vue?vue&type=template&id=5d857ef8&"
import script from "./appConfig.vue?vue&type=script&lang=js&"
export * from "./appConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xc01/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d857ef8')) {
      api.createRecord('5d857ef8', component.options)
    } else {
      api.reload('5d857ef8', component.options)
    }
    module.hot.accept("./appConfig.vue?vue&type=template&id=5d857ef8&", function () {
      api.rerender('5d857ef8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/app/appConfig/appConfig.vue"
export default component.exports